module.exports = __webpack_public_path__ + "img/jingdiangushi-1@3x.4bdc221a.png";